import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import styles from './ImpactAnalysis.module.scss';
import Summary from './summary/Summary';
import PricingParameters from './pricingparameters/PricingParameters';
import ImpactSummary from './impactsummary/ImpactSummary';
import ImpactDetailed from './impactdetailed/ImpactDetailed';
import {
    getPricingParametersLoaded, getImpactSummaryLoaded, getImpactDetailedLoaded
} from './selectors';
import { searchIdRequest } from './impactAnalysisIdSummary/actions';

const ImpactAnalysis = (props) => {
    const { searchIdRequest } = props;
    const { id } = props.match.params;
    const readOnly = useMemo(() => id !== undefined, [id]);
    useEffect(() => {
        if (readOnly) { searchIdRequest(id); }
    }, [searchIdRequest, id, readOnly]);

    return (
        <div className={ styles.summary }>
            <div className={ styles.header }>
                Impact Analysis
            </div>
            <Summary readOnly={ readOnly } />
            { props.pricingParametersLoaded && <PricingParameters readOnly={ readOnly } /> }
            { props.impactSummaryLoaded && <ImpactSummary readOnly={ readOnly } /> }
            { props.impactDetailedLoaded && !readOnly && <ImpactDetailed /> }
        </div>
    );
};

ImpactAnalysis.propTypes = {
    impactDetailedLoaded: PropTypes.bool,
    impactSummaryLoaded: PropTypes.bool,
    pricingParametersLoaded: PropTypes.bool,
    searchIdRequest: PropTypes.func.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string
        })
    }).isRequired
};

ImpactAnalysis.defaultProps = {
    impactDetailedLoaded: false,
    impactSummaryLoaded: false,
    pricingParametersLoaded: false
};

const mapStateToProps = state => ({
    impactDetailedLoaded: getImpactDetailedLoaded(state),
    impactSummaryLoaded: getImpactSummaryLoaded(state),
    pricingParametersLoaded: getPricingParametersLoaded(state)
});

const mapDispatchToProps = {
    searchIdRequest
};

export default withRouter(connect(mapStateToProps,
    mapDispatchToProps)(ImpactAnalysis));

export { ImpactAnalysis as ImpactAnalysisUnconnected };
